import TeamsPage from './TeamsPage';
import { TeamsPageProps, TeamsPageValueProps } from './types';

export type { TeamsPageProps, TeamsPageValueProps };
export default TeamsPage;
